import { getSessionStorageItem, setSessionStorageItem } from "./session-storage";

const KEY = "algoliaSearchQueryID";

export const saveQueryID = (id: string | undefined) => {
	if (!id) return;
	setSessionStorageItem<string>(KEY, id);
};

export const readQueryID = (): string | undefined => {
	return getSessionStorageItem<string>(KEY);
};
